import {
    AccountLockedForMisbehavior,
    AccountLockedTooManyAuthFailures,
    IncorrectEmailOrPassword,
    TryAgain,
    FatalError,
    BlankEmail,
    InvalidEmail,
    BlankPassword,
}
    from './SignInErrors';
import validator from 'email-validator';
import cookie from 'js-cookie';
import { createGaActionCreator } from '../utils';
import { SIGN_IN_GA_CATEGORY, GaActionText, TOO_MANY_AUTH_FAILURE_LOCKED_REDIRECT } from './constants';
import { getUser } from '../Layout/actions/user';
import { HttpStatusCodes } from '../constants';

export const ENTER_EMAIL = '@@signinform/ENTER_EMAIL';
export const ENTER_PASSWORD = '@@signinform/ENTER_PASSWORD';
export const CLICK_REMEMBER_ME = '@@signinform/CLICK_REMEMBER_ME';
export const SIGN_IN_SUCCESS = '@@signinform/SIGN_IN_SUCCESS';
export const SIGN_IN_FAILURE = '@@signinform/SIGN_IN_FAILURE';
export const SIGN_IN_AND_GET_USER_FAILURE = '@@signinform/SIGN_IN_AND_GET_USER_FAILURE';
export const SIGN_IN_START = '@@signinform/SIGN_IN_START';
export const SIGN_IN_PASSWORD_EXPIRED = '@@signinform/SIGN_IN_PASSWORD_EXPIRED';

export const TRACK_EMAIL_FIELD_SELECT = '@@signinform/TRACK_EMAIL_FIELD_SELECT';
export const TRACK_PASSWORD_FIELD_SELECT = '@@signinform/TRACK_PASSWORD_FIELD_SELECT';
export const TRACK_REMEMBER_ME_CHANGE = '@@signinform/TRACK_REMEMBER_ME_CHANGE';
export const TRACK_CLICK_FORGOT_PASSWORD = '@@signinform/TRACK_CLICK_FORGOT_PASSWORD';
export const TRACK_CLICK_RESET_PASSWORD = '@@signinform/TRACK_CLICK_RESET_PASSWORD';
export const TRACK_CLICK_CONTINUE = '@@signinform/TRACK_CLICK_CONTINUE';
export const TRACK_SHOW_LOCKED_ERROR = '@@signinform/TRACK_SHOW_LOCKED_ERROR';
export const TRACK_SHOW_LOCKED_RESET_PASSWORD = '@@signinform/TRACK_SHOW_LOCKED_RESET_PASSWORD';
export const TRACK_PASSWORD_EXPIRED = '@@signinform/TRACK_PASSWORD_EXPIRED';

export const SignInFormActions = {
    ENTER_EMAIL,
    ENTER_PASSWORD,
    CLICK_REMEMBER_ME,
    SIGN_IN_SUCCESS,
    SIGN_IN_FAILURE,
    SIGN_IN_START,
    SIGN_IN_PASSWORD_EXPIRED,
    TRACK_EMAIL_FIELD_SELECT,
    TRACK_PASSWORD_FIELD_SELECT,
    TRACK_REMEMBER_ME_CHANGE,
    TRACK_CLICK_FORGOT_PASSWORD,
    TRACK_CLICK_RESET_PASSWORD,
    TRACK_CLICK_CONTINUE,
    TRACK_SHOW_LOCKED_ERROR,
    TRACK_SHOW_LOCKED_RESET_PASSWORD,
    TRACK_PASSWORD_EXPIRED,
};

export const enterEmail = email => ({
    type: SignInFormActions.ENTER_EMAIL,
    email,
});

export const enterPassword = password => ({
    type: SignInFormActions.ENTER_PASSWORD,
    password,
});

export const clickRememberMe = rememberMe => ({
    type: SignInFormActions.CLICK_REMEMBER_ME,
    rememberMe,
});

export const signInSuccess = responseBody => ({
    type: SignInFormActions.SIGN_IN_SUCCESS,
    responseBody,
});

export const signInFailure = error => ({
    type: SignInFormActions.SIGN_IN_FAILURE,
    error,
});

export const signInStart = () => ({
    type: SignInFormActions.SIGN_IN_START,
});

export const signInAndgetUserFailure = error => ({
    type: SignInFormActions.SIGN_IN_AND_GET_USER_FAILURE,
    error,
});

export const signInPasswordExpired = () => ({
    type: SignInFormActions.SIGN_IN_PASSWORD_EXPIRED,
});

const apiHost = process.env.API_HOST || '';
const endpoint = `${apiHost}/api/rest/accounts/v1/authenticate`;

export function signInFetch(email, password, rememberMe) {
    return dispatch => {
        if (!email) return dispatch(signInFailure(BlankEmail));
        if (!validator.validate(email)) return dispatch(signInFailure(InvalidEmail));
        if (!password) return dispatch(signInFailure(BlankPassword));

        dispatch(signInStart());

        const fetchData = {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                username: email,
                password,
                rememberMe,
            }),
            credentials: 'include',
        };
        let responseStatus;
        return fetch(endpoint, fetchData)
            .then(response => {
                responseStatus = response.status;

                if (responseStatus === HttpStatusCodes.Forbidden) {
                    return response.json()
                        .then(body => {
                            if (body.locked) {
                                if (body.suggested_redirect === TOO_MANY_AUTH_FAILURE_LOCKED_REDIRECT) {
                                    return dispatch(signInFailure(AccountLockedTooManyAuthFailures));
                                } else {
                                    return dispatch(signInFailure(AccountLockedForMisbehavior));
                                }
                            } else {
                                return dispatch(signInFailure(IncorrectEmailOrPassword));
                            }
                        });
                }

                if (responseStatus === HttpStatusCodes.AuthenticationTimeout) {
                    return dispatch(signInPasswordExpired());
                }

                if (responseStatus >= 400) {
                    return dispatch(signInFailure(TryAgain));
                }

                return response.json()
                    .then(body => {
                        cookie.set('entityId', body.entity_id);
                        return dispatch(signInSuccess(body));
                    });
            })
            .catch(() => {
                dispatch(signInFailure(FatalError));
            });
    };
}

/*
    Tracking Actions
*/

export const trackEmailFieldSelect = () => createGaActionCreator(
    TRACK_EMAIL_FIELD_SELECT,
    SIGN_IN_GA_CATEGORY,
    GaActionText.trackEmailFieldSelect
);

export const trackPasswordFieldSelect = () => createGaActionCreator(
    TRACK_PASSWORD_FIELD_SELECT,
    SIGN_IN_GA_CATEGORY,
    GaActionText.trackPasswordFieldSelect
);

export const trackRememberMeChange = () => createGaActionCreator(
    TRACK_REMEMBER_ME_CHANGE,
    SIGN_IN_GA_CATEGORY,
    GaActionText.trackRememberMeChange
);

export const trackClickForgotPassword = () => createGaActionCreator(
    TRACK_CLICK_FORGOT_PASSWORD,
    SIGN_IN_GA_CATEGORY,
    GaActionText.trackClickForgotPassword
);

export const trackClickResetPassword = () => createGaActionCreator(
    TRACK_CLICK_RESET_PASSWORD,
    SIGN_IN_GA_CATEGORY,
    GaActionText.trackClickResetPassword
);

export const trackClickContinue = () => createGaActionCreator(
    TRACK_CLICK_CONTINUE,
    SIGN_IN_GA_CATEGORY,
    GaActionText.trackClickContinue
);

export const trackShowLockedError = () => createGaActionCreator(
    TRACK_SHOW_LOCKED_ERROR,
    SIGN_IN_GA_CATEGORY,
    GaActionText.trackShowLockedError,
);

export const trackShowLockedResetPassword = () => createGaActionCreator(
    TRACK_SHOW_LOCKED_RESET_PASSWORD,
    SIGN_IN_GA_CATEGORY,
    GaActionText.trackShowLockedResetPassword,
);

export const trackPasswordExpired = () => createGaActionCreator(
    TRACK_PASSWORD_EXPIRED,
    SIGN_IN_GA_CATEGORY,
    GaActionText.trackPasswordExpired,
);

export const signInFormTrackingActionCreators = {
    trackEmailFieldSelect,
    trackPasswordFieldSelect,
    trackRememberMeChange,
    trackClickForgotPassword,
    trackClickResetPassword,
    trackClickContinue,
    trackPasswordExpired,
    trackShowLockedError,
    trackShowLockedResetPassword,
};

export function signInAndGetUser(email, password, rememberMe) {
    return async dispatch => {
        try {
            const signInFetchResponse = await dispatch(signInFetch(email, password, rememberMe));
            if (signInFetchResponse.type === SIGN_IN_SUCCESS) {
                return dispatch(getUser());
            }
        } catch (e) {
            return dispatch(signInAndgetUserFailure(e));
        }
    };
}
